import Keycloak from 'keycloak-js';

import { UserDetails } from '../utils/Types';

/**
 * Initialize the Keycloak instance with the env in the public folder
 */
const _kc: Keycloak = new Keycloak(process.env.REACT_APP_KEYCLOAK_JSON!);

/**
 * Initializes Keycloak instance.
 * @param onAuthenticatedCallback Callback function to be called after initialization.
 */
const initKeycloak = (onAuthenticatedCallback: any) => {
  _kc
    .init({
      onLoad: 'login-required',
      checkLoginIframe: false,
    })
    .then(() => {
      onAuthenticatedCallback();
    })
    .catch(console.error);
};

const doLogin = _kc.login;

const doLogout = _kc.logout;

const getToken = () => _kc.token;

const isLoggedIn = () => !!_kc.token;

const updateToken = (successCallback: any) => _kc.updateToken(5).then(successCallback).catch(doLogin);

const getUsername = () => _kc.tokenParsed?.preferred_username;

const getUserDetails = (): UserDetails => {
  return {
    firstname: _kc.tokenParsed?.given_name,
    lastname: _kc.tokenParsed?.family_name,
    email: _kc.tokenParsed?.email,
    phone: 'NA',
    country: 'AN',
    company: 'NA',
  };
};

const UserService = {
  initKeycloak,
  doLogin,
  doLogout,
  isLoggedIn,
  getToken,
  updateToken,
  getUserDetails,
  getUsername,
};

export default UserService;
